'use client';
import { convertOffsetParentRelativeRectToViewportRelativeRect } from './platformFns/convertOffsetParentRelativeRectToViewportRelativeRect.js';
import { getDocumentElement, isElement } from '../utils/dom.js';
import { getClippingRect } from './platformFns/getClippingRect.js';
import { getOffsetParent } from './platformFns/getOffsetParent.js';
import { getElementRects } from './platformFns/getElementRects.js';
import { getClientRects } from './platformFns/getClientRects.js';
import { getDimensions } from './platformFns/getDimensions.js';
import { getScale } from './platformFns/getScale.js';
import { isRTL } from './platformFns/isRTL.js';

var platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: getDocumentElement,
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: isElement,
    isRTL: isRTL
};

export { platform };
